module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/drum-v2-790fc534dbfb4a8228132d0a784f53f6.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/drum-v2.svg
// module id = 9cWJ
// module chunks = 1 3 10 12 18